export default __webpack_public_path__ + "static/media/kitchen3-after2-2048w.fbf4ccd0.png";